import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '../server';
import { SSEClient } from './sse-client';


export const trpc = createTRPCClient<AppRouter>({
  links: [httpBatchLink({ url: '/trpc' })],
});

export function connectSSE() {
  const socket = new SSEClient('http://localhost:3333/socket');

  const logEl = document.getElementById('log');
  function logLine(text: string) {
    console.log('_--_', text);
  }

  socket.on('connect', (payload) => {
    logLine(`✅ Connected as ${payload.clientId}`);
  });

  // 2) If server just sends a "welcome":
  socket.on('welcome', (data) => {
    logLine(`🎉 Server says: "${data.msg}"`);
  });

  // 3) **NEW**: Client should handle the query event "count-indexeddb":
  socket.on('count-indexeddb', async (payload) => {
    const { requestId, data } = payload;
    logLine(
      `��️‍♂️ Received query "count-indexeddb" with data: ${JSON.stringify(data)}`
    );
    const fakeCount = Math.floor(Math.random() * 100);
    // Use the new API for query response
    socket.emitQueryResponse(requestId, fakeCount);
    logLine(`↩️ Sent response: requestId=${requestId}, count=${fakeCount}`);
  });

  // 5) (Optional) Listen for broadcast announcements
  socket.on('announcement', (payload) => {
    logLine(`📢 Announcement: ${JSON.stringify(payload)}`);
  });

  // 6) (Optional) Catch‐all "message"
  socket.on('message', (payload) => {
    logLine(`💬 [message] ${JSON.stringify(payload)}`);
  });
}
